<template>
    <div class="button-wrapper">
        <!-- Send to Perfect Score Button -->
        <loading-icon-text-button
            class="md-warning"
            @click="confirmSendPerfectScoreDialog()"
            :loading="isPerfectScoreRequest"
            :toolTipText="perfectScoreToolTipText"
            :toolTipDirection="perfectScoreToolTipDirection"
        >
            Send to Perfect Score
        </loading-icon-text-button>

        <!-- Show Send to Perfect Score Dialog -->
        <md-dialog
            :md-active.sync="showSendPerfectScoreDialog"
            :md-click-outside-to-close="false"
            :md-close-on-esc="false"
            class="show_possible_matches_dialog"
            >
            <md-dialog-title>Send to Perfect Score</md-dialog-title>
            <md-dialog-content>
                <div class="md-layout md-size-100">
                    <validated-text-input
                        class="md-layout-item md-small-size-100"
                        label="Note (required)"
                        v-model="perfectScoreComment"
                        errormsg="Please enter a comment"
                        required
                    >
                    </validated-text-input>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary md-simple" @click="onCloseSendPerfectScoreDialog"> Cancel </md-button>
                <loading-icon-text-button @click="confirmRequest" :loading="isPerfectScoreRequest" :disabled="isPerfectScoreRequest || !perfectScoreComment">
                    Send to Perfect Score
                </loading-icon-text-button>
            </md-dialog-actions>
        </md-dialog>

        <!-- Success Message -->
        <md-snackbar
            :md-active.sync="snackbar.show"
            :md-duration="8000"
            class="editApplicantPossibleMatchSnackbar"
        >
            <span>
            <template v-if="snackbar.icon">
                <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
                &nbsp;&nbsp;&nbsp;
            </template>
            {{ snackbar.content }}
            </span>
            <md-button class="md-simple" @click="snackbar.show = false"
            >Dismiss</md-button
            >
        </md-snackbar>

        <!-- Alert Dialog  -->
        <md-dialog-alert
            class="editApplicantPossibleMatchErrorDialog"
            :md-active.sync="error_dialog.show"
            :md-title="error_dialog.title"
            :md-content="error_dialog.content"
        />
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import LoadingIconTextButton from "@/components/LoadingIconTextButton";
    import ValidatedInputs from '@/components/ValidatedInput';

    export default{
        components: {
            LoadingIconTextButton,
            ...ValidatedInputs,
        },
        data(){
            return {
                showModal: true,
                error_dialog: {
                    show: false,
                    title: "",
                    content: "",
                },
                snackbar: {
                    show: false,
                    icon: "done",
                    content: "",
                },
                showSendPerfectScoreDialog: false,
                perfectScoreComment: '',
                isPerfectScoreRequest: false,
                perfectScoreToolTipText: "Send to Perfect Score to clean your client's credit file and get the lead returned to you once ready to re-apply.",
                perfectScoreToolTipDirection: "right"
            };
        },
        props: {
        },
        computed: {
            ...mapGetters({
                application: "application",
                userHasPermission: 'userHasPermission'
            }),
            applicant () {
                return this.application?.applicants?.[0] || null;
            }
        },
        methods: {

            showErrorDialog(message, title = "Error") {
                this.error_dialog.show = true;
                this.error_dialog.title = title;
                this.error_dialog.content = message;
            },

            showSuccessDialog(message) {
                this.snackbar.show = true;
                this.snackbar.icon = "done";
                this.snackbar.content = message;
            },

            async confirmSendPerfectScoreDialog() {
                const broker = this.application.owners.find(owner => owner.role == 'Broker')
                if (broker?.name?.firstname) {
                    this.showSendPerfectScoreDialog = true
                } else {
                    this.showErrorDialog('Please assign a broker before proceeding.', 'No broker is assigned')
                    return
                }
            },

            async confirmRequest() {
                const broker = this.application.owners.find(owner => owner.role == 'Broker')
                const brokerName = `${broker.name.firstname} ${broker.name.lastname}`
                const contactName = `${this.applicant.contact.name.firstname} ${this.applicant.contact.name.lastname}`
                const payload = {
                    subject: `Lead Refer from - ${brokerName} - ${contactName} - ${this.application.loan.id}`,
                    body: `
                    Application Id: ${this.application.loan.id} <br>
                    Broker: ${brokerName} <br>
                    Customer : ${contactName} <br>
                    Note: ${this.perfectScoreComment}
                    `,
                    application_id: this.application.loan.id
                }
                this.isPerfectScoreRequest = true
                try {
                    await axios.post('/api/v1/applicant/sendPerfectScoreEmail', payload)
                    this.showSendPerfectScoreDialog = false;
                    this.application.loan.comments.push({
                        tag: 'Perfect Score',
                        content: 'Referred to Perfect Score Program',
                        completed: false,
                        name: {
                            first_name: this.$store.state.user.first_name,
                            last_name: this.$store.state.user.last_name,
                        },
                    });
                    this.showSuccessDialog('Perfect score request sent successfully');
                } catch (error) {
                    console.log(error)
                    this.showErrorDialog('Error with Perfect score request', error.message)
                } finally {
                    this.isPerfectScoreRequest = false;
                }
            },

            onCloseSendPerfectScoreDialog() {
                this.showSendPerfectScoreDialog = false
            },
        },
    };
</script>
<style scoped>
.button-wrapper {
  display: inline-flex;
  align-items: center;
}
</style>
